import { getToken } from "@/utils/localstorage";
import axios from "axios";

export async function createFormatTemplate(formatId: string, data: any) {
  const apiUrl = process.env.API_URL;
  const authToken = await getToken();
  const response = await axios.post(`${apiUrl}/create-format-template`, data, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    params: { formatId },
  });
  return response.data;
}
